module.exports = __webpack_public_path__ + "img/forever-link-register-hero.1ea1b130.jpg";